/**
 * HAFA Innenmaß-Bild i18n-Swap
 * --------------------------------------------------------------
 * 18 Renovierungsstufen-Produkte zeigen als Position 3 das Bild
 * "Innenmaß-Skizze" (innenmass_2_<guid>.jpg). Auf der polnischen
 * Storefront wird stattdessen das PL-Pendant innenmass_2_pl.jpg
 * angezeigt.
 *
 * Strategie: clientseitiger Swap von src + srcset, sobald Locale=pl.
 * Funktioniert auch für lazy-loaded Bilder (Lightbox, Galerie).
 *
 * Stand: 2026-06-09  / schodyhafa.pl / HAFA Stairs
 */
(function () {
  'use strict';

  var lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  if (lang !== 'pl') return;

  var PL_BASE = 'https://cdn.shopify.com/s/files/1/0962/9132/4233/files/innenmass_2_pl.jpg';

  // Match: innenmass_2_<guid>.jpg (mit optionalem CDN-Resize-Suffix _NNNxNNN)
  // Beispiel: innenmass_2_0ac5262f-ce15-4caf-901e-c6d6051939bf.jpg
  //           innenmass_2_0ac5262f-ce15-4caf-901e-c6d6051939bf_180x180.jpg
  var FILENAME_RE = /innenmass_2_[a-f0-9\-]{8,}(?:_\d+x\d*)?\.jpg/i;

  function isMatch(url) { return url && FILENAME_RE.test(url); }

  function extractWidth(url) {
    // CDN-Resize-Suffix: innenmass_2_<guid>_180x180.jpg → 180
    var m = url.match(/_(\d+)x\d*\.jpg/i);
    if (m) return parseInt(m[1], 10);
    // Shopify ?width=N Parameter
    var p = url.match(/[?&]width=(\d+)/i);
    if (p) return parseInt(p[1], 10);
    return null;
  }

  function buildPlUrl(width) {
    return width ? PL_BASE + '?width=' + width : PL_BASE;
  }

  function swapSrcset(srcset) {
    if (!srcset) return srcset;
    return srcset.split(',').map(function (entry) {
      var trimmed = entry.trim();
      if (!trimmed) return trimmed;
      var parts = trimmed.split(/\s+/);
      var url = parts[0];
      var descriptor = parts.slice(1).join(' ');
      if (!isMatch(url)) return trimmed;
      // Width aus Descriptor (z.B. "180w") oder aus URL extrahieren
      var w = null;
      var descMatch = descriptor.match(/(\d+)w/i);
      if (descMatch) w = parseInt(descMatch[1], 10);
      else w = extractWidth(url);
      return buildPlUrl(w) + (descriptor ? ' ' + descriptor : '');
    }).join(', ');
  }

  function swapImg(img) {
    if (!img || img.dataset.hafaInnenmassSwapped === '1') return;

    var src = img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset') || '';
    var dataSrc = img.getAttribute('data-src') || '';
    var dataSrcset = img.getAttribute('data-srcset') || '';

    var changed = false;

    if (isMatch(src)) {
      img.setAttribute('src', buildPlUrl(extractWidth(src)));
      changed = true;
    }
    if (isMatch(dataSrc)) {
      img.setAttribute('data-src', buildPlUrl(extractWidth(dataSrc)));
      changed = true;
    }
    if (srcset && /innenmass_2_[a-f0-9\-]{8,}/i.test(srcset)) {
      img.setAttribute('srcset', swapSrcset(srcset));
      changed = true;
    }
    if (dataSrcset && /innenmass_2_[a-f0-9\-]{8,}/i.test(dataSrcset)) {
      img.setAttribute('data-srcset', swapSrcset(dataSrcset));
      changed = true;
    }

    // Alt-Text auf PL falls noch DE
    if (changed) {
      var alt = img.getAttribute('alt') || '';
      if (/innenmaß|stufentiefe/i.test(alt)) {
        img.setAttribute('alt', 'Głębokość wewnętrzna stopnia');
      }
      img.dataset.hafaInnenmassSwapped = '1';
    }
  }

  function swapAllImages(root) {
    (root || document).querySelectorAll('img').forEach(swapImg);
    // Auch <source> in <picture>
    (root || document).querySelectorAll('source[srcset], source[src]').forEach(function (s) {
      var srcset = s.getAttribute('srcset') || '';
      var src = s.getAttribute('src') || '';
      if (srcset && /innenmass_2_[a-f0-9\-]{8,}/i.test(srcset)) {
        s.setAttribute('srcset', swapSrcset(srcset));
      }
      if (isMatch(src)) {
        s.setAttribute('src', buildPlUrl(extractWidth(src)));
      }
    });
  }

  function init() {
    swapAllImages(document);
    // Watch für lazy-loaded (Galerie, Lightbox, Zoom)
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG') {
            swapImg(m.target);
          } else if (m.type === 'childList') {
            m.addedNodes.forEach(function (n) {
              if (n.nodeType !== 1) return;
              if (n.tagName === 'IMG') swapImg(n);
              else if (n.querySelectorAll) swapAllImages(n);
            });
          }
        });
      }).observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
